import Layout from '@/layout';
var rsRouter = {
  path: '/rs',
  component: Layout,
  redirect: '/rs/merchant',
  name: 'RS',
  meta: {
    title: 'RS管理',
    icon: 'el-icon-office-building'
  },
  children: [{
    path: 'merchant',
    component: function component() {
      return import('@/views/rs/merchant/index');
    },
    name: 'RSMerchantList',
    meta: {
      title: '商户管理',
      icon: 'el-icon-s-custom'
    }
  }, {
    path: 'merchant/store',
    component: function component() {
      return import('@/views/rs/merchant/store/index');
    },
    name: 'RSStoreManagement',
    meta: {
      title: '店铺管理',
      icon: 'el-icon-s-shop'
    }
  }, {
    path: 'merchant/detail',
    component: function component() {
      return import('@/views/rs/merchant/detail');
    },
    name: 'RSMerchantDetail',
    meta: {
      title: '商户详情',
      icon: 'el-icon-document'
    },
    hidden: true
  }, {
    path: 'merchant/oneCardMerchant',
    component: function component() {
      return import('@/views/rs/merchant/oneCardMerchant/index');
    },
    name: 'RSOneCardMerchant',
    meta: {
      title: '一卡通商品SKU管理',
      icon: 'el-icon-goods'
    }
  }]
};
export default rsRouter;